import Cookie from 'js-cookie'
export const getLocal = key => {
  try {
    if (localStorage) {
      if (localStorage.getItem(key)) {
        return localStorage.getItem(key)
      } else {
        return null
      }
    } else {
      return JSON.parse(Cookie.get(key))
    }
  } catch (e) {
    console.error(e)
  }
}

export const setLocal = (key, value) => {
  try {
    if (localStorage) {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      Cookie.set(key, JSON.stringify(value))
    }
  } catch (e) {
    console.error(e)
  }
}

export const delLocal = key => {
  try {
    if (localStorage) {
      localStorage.removeItem(key)
    } else {
      Cookie.remove(key)
    }
  } catch (e) {
    console.error(e)
  }
}
